import useSetInitialTestingData from './useSetInitialTestingData';
import useTestStory from './useTestStory';
function useTestAllStories({ view, metadataProviderRef, }) {
    useSetInitialTestingData({
        view,
    });
    useTestStory({
        metadataProviderRef,
    });
}
export default useTestAllStories;
//# sourceMappingURL=useTestAllStories.js.map